module.exports = __webpack_public_path__ + "static/media/mt.1eca6df8.svg";